import dmi from './utils/deep-merge-inmutable';
import base from './base';
export default dmi(base, {
    message: {
        publishedEforms: {
            paginator: {
                rowsByPage: "Resultados por página",
            }
        },
        userActive: {
            numero_legajo_aprobador: "Nombre del aprobador",
        },
        label: {
            dni: "Número de documento",
        },
        publishDocuments: {
            configIndivualPublish: {
                inputCuil: {
                    label: "CI",
                    question: "¿Cuál es el CI del colaborador?",
                    description: "Ingresa el CI del colaborador al que quieres enviarle un documento"
                },
            }
        },
        certificates: {
            newCertificate: {
                personalInfo: {
                    dni: "CI",
                },
                dni: "CI"
            }
        }
    }
})